import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {
  Form,
  FormGroup,
  FormControl,
  FormCheck,
  FormLabel,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../../../assets/images/logo.png";
import "./style.css";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

const Step2 = ({ showModal, handleModal2Close, openSigninModal }) => {
  const [pseudo, setPseudo] = useState("");
  const [password, setPassword] = useState("");

  const [birthDate, setBirthDate] = useState({
    day: "",
    month: "",
    year: "",
  });

  const [phoneNumbers, setPhoneNumbers] = useState("");

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const years = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );

  return (
    <div>
      <Modal
        show={showModal}
        onHide={handleModal2Close}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom-modal-dialog"
      >
        <Modal.Header
          closeButton
          style={{
            background:
              "linear-gradient(to right, #fff6e9 0%,rgb(238, 217, 187) 200%)",
            padding: "10px",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ height: "12px", marginRight: "auto" }}
          />
        </Modal.Header>
        <Modal.Body className="step2-body">
          <Modal.Title
            className="h6 text-center w-100"
            style={{ color: "grey" }}
          >
            Register now and discover our services
          </Modal.Title>
          <Form>
            <FormGroup controlId="pseudo" className="mt-3">
              <div className="d-flex justify-content-between">
                <div
                  style={{
                    marginLeft: "60px",
                    fontSize: "14px",
                    width: "190px",
                  }}
                >
                  <FormLabel>Pseudo</FormLabel>
                  <FormControl
                    type="text"
                    value={pseudo}
                    onChange={(e) => setPseudo(e.target.value)}
                    className="w-80"
                  />
                </div>
                <div
                  style={{
                    marginRight: "60px",
                    fontSize: "14px",
                    width: "210px",
                  }}
                >
                  <FormLabel>Password</FormLabel>
                  <FormControl
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-80"
                  />
                </div>
              </div>
            </FormGroup>

            <FormGroup controlId="contact" className="mt-3">
              <div className="d-flex justify-content-between">
                <div
                  style={{
                    marginLeft: "60px",
                    fontSize: "14px",
                    width: "190px",
                  }}
                >
                  <FormLabel style={{ fontSize: "14px" }}>
                    Phone number
                  </FormLabel>

                  <PhoneInput
                    defaultCountry="us"
                    value={phoneNumbers}
                    onChange={(e) => setPhoneNumbers(e)}
                    className="form-control p-0"
                    style={{
                      border: "1px solid #dee2e6",
                      borderRadius: "0.375rem",
                     
                    }}
                    inputStyle={{
                      width: "100%",
                      height:"34px",
                      border: "none",
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      paddingLeft: "8px",
                    }}
                    countrySelectorStyleProps={{
                      buttonStyle: {
                        border: "none",
                        borderRight: "1px solid #dee2e6",
                        borderRadius: "0.375rem 0 0 0.375rem",
                        backgroundColor: "transparent",
                        height:"34px",
                      },
                    }}
                  />
                </div>
                <div
                  style={{
                    marginRight: "60px",
                    fontSize: "14px",
                    width: "210px",
             
                  }}
                >
                  <FormLabel style={{ fontSize: "14px" }}>Birthdate</FormLabel>
                  <div className="d-flex justify-content-between">
                    <FormControl
                      as="select"
                      value={birthDate.day}
                      onChange={(e) =>
                        setBirthDate({ ...birthDate, day: e.target.value })
                      }
                      className="w-30"
                      
                      style={{ fontSize: "14px",color:"grey",  width:'45%'}}
                    >
                      <option value="">Day</option>
                      {days.map((day) => (
                        <option key={day} value={day}>
                          {day}
                        </option>
                      ))}
                    </FormControl>
                    <FormControl
                      as="select"
                      value={birthDate.month}
                      onChange={(e) =>
                        setBirthDate({ ...birthDate, month: e.target.value })
                      }
                      className="w-30 mx-1"
                      style={{ fontSize: "14px" ,color:"grey" }}
                    >
                      <option value="">Month</option>
                      {months.map((month, index) => (
                        <option key={index} value={month}>
                          {month}
                        </option>
                      ))}
                    </FormControl>
                    <FormControl
                      as="select"
                      value={birthDate.year}
                      onChange={(e) =>
                        setBirthDate({ ...birthDate, year: e.target.value })
                      }
                      className="w-30"
                      style={{ fontSize: "14px" ,color:"grey" ,width:'50%' }}
                    >
                      <option value="">Year</option>
                      {years.map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </FormControl>
                  </div>
                </div>
              </div>
            </FormGroup>

            <div style={{ marginTop: "20px" }}>
              <Button
                variant="primary"
                // onClick={handleContinueClick}
                style={{
                  backgroundColor: "#FF6347",
                  borderColor: "#FF6347",
                  width: "77%",
                  margin: "0 auto",
                  display: "block",
                }}
              >
                Register
              </Button>
            </div>
          </Form>
          <div className="text-center" style={{ marginTop: "10px" }}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleModal2Close();
                openSigninModal();
              }}
              style={{
                textDecoration: "underline",
                color: "grey",
                fontSize: "14px",
              }}
            >
              Already have an account, Sign In
            </a>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Step2;
